import logger from 'structure-logger'
import r from 'structure-driver'
import StructureComposeError from 'structure-compose-error'
import errorCodes from 'structure-error-codes'

const errorComposer = new StructureComposeError(errorCodes)

const apiRoot = `/api/${process.env.API_VERSION}`
const whitelistedRoutes = [
  ['GET', `${apiRoot}$`],
  // Don't need next part of middleware for creating an organization
  ['POST', `${apiRoot}/organizations$`],
  // If inital page load, it's possible to not know any of this info until sync
  ['POST', `${apiRoot}/sync`],
  ['GET', `${apiRoot}/applications/by/hosts$`],
  ['GET', `${apiRoot}/digital-assets/.*/html$`],
]

function isWhiteListedUrl(req) {

  for (const route of whitelistedRoutes) {

    if (route[0] !== req.method) {
      continue
    }

    const re = new RegExp(route[1])

    if (re.test(req.originalUrl)) {
      return true
    }

  }

  return false

}

function isOrganizationValid(id) {

  return new Promise( async (resolve, reject) => {

    try {
      const res = await r.table('organizations').get(id)

      if(res && res.id == id) {
        resolve(true)
      }

      else {
        resolve(false)
      }

    }
    catch(e) {
      logger.error(e)

      reject(e)
    }

  })

}

export default async function authenticateApplicationEntity(req, res, next) {

  const applicationId = req.headers.applicationid
  const organizationId = req.headers.organizationid

  if (isWhiteListedUrl(req)) {
    return next()
  }

  if(!organizationId) {
    logger.debug('ORGANIZATIONID_MISSING', organizationId)

    return next(errorComposer.compose(
      'ORGANIZATIONID_MISSING',
      {},
      {status: 404}
    ))
  }

  if(typeof organizationId != 'string') {
    logger.debug('ORGANIZATIONID_INVALID', organizationId)

    return next(errorComposer.compose(
      'ORGANIZATIONID_INVALID',
      {},
      {status: 400}
    ))
  }

  /*
  NOTE:
  try/catch is used to catch short ids that are missing
  */
  try {
    const isOrganizationIdValid = await isOrganizationValid(organizationId)

    if(!isOrganizationIdValid) {
      logger.debug('ORGANIZATIONID_INVALID', organizationId)

      return next(errorComposer.compose('ORGANIZATIONID_INVALID'))
    }
  }
  catch(e) {
    logger.error(e)

    return next(errorComposer.compose('ORGANIZATIONID_INVALID'))
  }

  // Don't need next part of middleware for creating an application
  if(req.originalUrl.indexOf('/api/0.1/applications') > -1 && req.method == 'POST') {
    return next()
  }

  if(!applicationId) {
    logger.debug('APPLICATIONID_MISSING', applicationId)

    return next(errorComposer.compose(
      'APPLICATIONID_MISSING',
      {},
      {status: 404}
    ))
  }

  if(typeof applicationId != 'string') {
    logger.debug('APPLICATIONID_INVALID', applicationId)

    return next(errorComposer.compose('APPLICATIONID_INVALID'))
  }

  // OK
  next()

}
